// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"f22857bd","453":"17311d1c"}[chunkId] + ".chunk.js";
};